import { render, staticRenderFns } from "./AdministracionReportes.vue?vue&type=template&id=319e49c3&"
import script from "./AdministracionReportes.vue?vue&type=script&lang=js&"
export * from "./AdministracionReportes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports